import { render } from "./AddSalesReturn.vue?vue&type=template&id=4dae21da"
import script from "./AddSalesReturn.vue?vue&type=script&lang=js"
export * from "./AddSalesReturn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__